var hasVotedBool = false;

export function formatRelativeTime(isoDateString) {
  if (!isoDateString)
    return '';

  const diffSec = Math.floor((Date.now() - new Date(isoDateString).getTime()) / 1000);

  if (diffSec < 60)
    return 'gerade eben';

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60)
    return `vor ${diffMin} Minute${diffMin === 1 ? '' : 'n'}`;

  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24)
    return `vor ${diffH} Stunde${diffH === 1 ? '' : 'n'}`;

  const diffD = Math.floor(diffH / 24);
  return `vor ${diffD} Tag${diffD === 1 ? '' : 'en'}`;
}

// Hex-Werte spiegeln die --result-*-Tokens in custom.css. Sie stehen hier bewusst als
// Literale, weil ApexCharts Farben als Strings braucht und CSS-Variablen nicht aufloest.
// Remis war frueher #5b6978 - das erreicht auf --chart-surface nur 2.93:1 und lag damit
// unter der 3:1-Schwelle fuer Marks; #7a8899 kommt auf 4.56:1.
export function getColorForEvent(eventData) {
    if (!eventData || eventData.type != 1)
      return "#abcdef";
    if (eventData.points == 0)
      return "#ff4560";
    if (eventData.points == 1)
      return "#7a8899";
    if (eventData.points == 3)
      return "#3dcc5b";
    return "#7a8899"; // Spiel ohne erfasstes Ergebnis (points == null)
  }

export function setHasVoted(){
  hasVotedBool = true;
}

export function hasVoted(){   return hasVotedBool; }